<script>
	import { Button, Col, Row } from "sveltestrap";
	import { form, field } from "svelte-forms";
	import ImportedCsvTable from "./Manage/ImportedCsvTable.svelte";
	import { required } from "svelte-forms/validators";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import client from "../../services/client";
	import Swal from "sweetalert2";
	import {
		errorMessage,
		loading,
		createBlackoutData,
		blackoutCarData,
		carSelection,
		editBlackoutData,
	} from "../../store/store";
	import SveltyPicker from "svelty-picker";
	import { navigate } from "svelte-routing";
	import { onMount } from "svelte";
	import { extractErrorMessage } from "../../utils/misc";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";

	export let blackoutId;

	onMount(() => {
		if (!blackoutId) {
			editBlackoutData.set({ id: "", stats: false });
		}
	});

	let files;
	$: csvUrl = "";
	let blackoutStartDate = field(
		"blackoutStartDate",
		!$createBlackoutData && !blackoutId
			? ""
			: $createBlackoutData?.blackoutStartDate,
		[required()]
	);

	let blackoutEndDate = field(
		"blackoutEndDate",
		!$createBlackoutData ? "" : $createBlackoutData?.blackoutEndDate,
		[required()]
	);

	let reason = field(
		"reason",
		!$createBlackoutData ? "" : $createBlackoutData?.reason,
		[required()]
	);
	let vehicleId = field("vehicleId", "", [required()]);
	let csvFile = field("csvFile", "");

	const myForm = form(
		blackoutStartDate,
		blackoutEndDate,
		reason,
		vehicleId,
		csvFile
	);

	async function handleSubmit() {
		let blackoutVehicles = [];
		for (let i = 0; i < $blackoutCarData.length; i++) {
			blackoutVehicles.push({
				vehicleId: $blackoutCarData[i].id,
			});
		}
		loading.set(true);

		const startDay = new Date($blackoutStartDate.value);
		const endDay = new Date($blackoutEndDate.value);
		const startDate = startDay;
		const endDate = endDay;
		try {
			const res = await client("/v1/blackouts", {
				method: `${blackoutId ? "PUT" : "POST"}`,
				version: "Vehicle",
				data: !$createBlackoutData.csvFile
					? {
							blackoutStartTime: new Date(startDate),
							blackoutEndTime: new Date(endDate),
							reason: $reason.value,
							blackoutVehicles,
							csvFile: csvUrl,
							id: blackoutId,
					  }
					: {
							blackoutStartTime: new Date(startDate),
							blackoutEndTime: new Date(endDate),
							reason: $reason.value,
							blackoutVehicles,
							csvFile: !$createBlackoutData.csvFile
								? null
								: $createBlackoutData.csvFile,
							id: blackoutId,
					  },
			});

			loading.set(false);

			if (res.status == 200) {
				Swal.fire({
					title: "Success",
					text: `Blackout ${
						blackoutId ? "updated" : "created"
					} successfully"`,
					type: "success",
					confirmButtonText: "OK",
					customClass: {
						confirmButton: "custom-ok-button",
					},
				}).then((result) => {
					if (result.isConfirmed) {
						createBlackoutData.set("");
						blackoutCarData.set("");
						carSelection.set([]);
						navigate("/blackout-management");
					}
				});
			} else {
				Swal.fire({
					title: "Error",
					text: res.data.error_msg,
					type: "error",
					confirmButtonText: "OK",
				});
			}

			// navigate("/car-management");
		} catch (error) {
			loading.set(false);
			console.log(error.response);
			extractErrorMessage(error);
		}
	}

	$: timeValidation = false;
	$: if (
		new Date($blackoutEndDate.value) < new Date($blackoutStartDate.value)
	) {
		timeValidation = true;
	} else {
		timeValidation = false;
	}

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	function handleCSV(e) {
		const file = e.target.files[0];

		if (e.target.files[0] !== undefined) {
			// Encode the file using the FileReader API
			let filereader = new FileReader();
			filereader.readAsDataURL(file);
			filereader.onload = function (evt) {
				let base64 = evt.target.result;
				csvUrl = base64;
			};
		} else {
			csvUrl = "";
		}
	}
</script>

<Row>
	<Col>
		<div>
			<PageHeader
				title={blackoutId ? "Edit Blackout" : "Create Blackout"}
			/>
			<ErrorMessageHandler message={err} />
			<Row>
				<Col xs={2}>
					<label for="blackoutStartDate" class="d-block mt-3">
						<span> <b>Blackout Start Date*</b> </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={2}>
					<SveltyPicker
						inputClasses="form-control getgo input {$myForm.hasError(
							'blackoutStartDate.required'
						)
							? 'border border-danger'
							: ''}"
						format="yyyy-mm-dd hh:ii"
						startDate={new Date()}
						placeholder="YYYY-MM-DD HH:MM"
						bind:value={$blackoutStartDate.value}
					/>
					{#if $myForm.hasError("blackoutStartDate.required")}
						<div>
							<p class="error-text">
								blackout start date is required
							</p>
						</div>
					{/if}
				</Col>
			</Row>

			<Row>
				<Col xs={2}>
					<label for="blackoutEndDate" class="d-block mt-3">
						<span> <b>Blackout End Date*</b> </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={2}>
					<SveltyPicker
						inputClasses="form-control getgo input {$myForm.hasError(
							'blackoutEndDate.required'
						) || timeValidation
							? 'border border-danger'
							: ''}"
						format="yyyy-mm-dd hh:ii"
						placeholder="YYYY-MM-DD HH:MM"
						startDate={new Date()}
						bind:value={$blackoutEndDate.value}
					/>
					{#if $myForm.hasError("blackoutEndDate.required")}
						<div>
							<p class="error-text">
								blackout start date is required
							</p>
						</div>
					{:else if timeValidation}
						<div>
							<p class="error-text">
								Blackout end date cannot be later than start
								date
							</p>
						</div>
					{/if}
				</Col>
			</Row>

			<Row>
				<Col xs={2}>
					<label for="reason" class="d-block mt-3">
						<span> <b>Reason*</b> </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={5}>
					<CustomInput
						type="text"
						bind:value={$reason.value}
						error={$myForm.hasError("reason.required")}
						errorText="Reason is required"
					/>
				</Col>
			</Row>
			{#if !$createBlackoutData.csvFile}
				<Row>
					<Col xs={2}>
						<label for="reason" class="d-block mt-3">
							<span> <b>CSV File</b> {$csvFile.value}</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<label for="csvFile">
							<span
								><input
									id="csvInput"
									type="file"
									multiple={false}
									bind:files
									on:change={(e) => handleCSV(e)}
								/>
							</span>
						</label>
					</Col>
				</Row>
			{/if}
			<Row>
				<Col class="d-flex justify-content-end gap-3">
					<!-- {#if !$blackoutCarData || blackoutId} -->
					<Button
						class="themeButton primary"
						disabled={!$reason.value ||
							!$blackoutStartDate.value ||
							!$blackoutEndDate.value ||
							timeValidation ||
							csvUrl}
						on:click={() => {
							createBlackoutData.set({
								reason: $reason.value,
								blackoutStartDate: $blackoutStartDate.value,
								blackoutEndDate: $blackoutEndDate.value,
								csvFile: csvUrl,
							});
							navigate("/blackout-management/create/select-car");
						}}>Add Car</Button
					>
					<!-- {/if} -->

					{#if !$loading}
						<Button
							class="themeButton primary"
							disabled={!$reason.value ||
								!$blackoutStartDate.value ||
								!$blackoutEndDate.value ||
								timeValidation ||
								(!$blackoutCarData && csvUrl == "")}
							on:click={() => {
								handleSubmit();
							}}
							on:click={!$myForm.valid}>Save</Button
						>
					{:else if $loading}
						<Button
							class="themeButton primary px-4"
							type="button"
							disabled
						>
							<span
								class="spinner-grow spinner-grow-sm"
								role="status"
								aria-hidden="true"
							/>
							Loading...
						</Button>
					{/if}
				</Col>
			</Row>
			<Col class="my-2">
				<ImportedCsvTable />
			</Col>
		</div>
	</Col>
</Row>

<style>
	:global(.custom-ok-button) {
		background: #19f9b9 !important;
		color: #011851 !important;
		outline: 0 !important;
		box-shadow: unset !important;
		border: unset !important;
	}
</style>
